import type { ThreadControllerEvent, ThreadControllerState } from './types';

export const initialThreadControllerState: ThreadControllerState = {
  activeThreadId: null,
  phase: 'idle',
  pendingSource: null,
  threadless: true,
};

export function createThreadControllerState(urlThreadId: string | null): ThreadControllerState {
  if (!urlThreadId) return initialThreadControllerState;
  return {
    activeThreadId: urlThreadId,
    phase: 'active',
    pendingSource: 'url_nav',
    threadless: false,
  };
}

export function threadControllerReducer(
  state: ThreadControllerState,
  event: ThreadControllerEvent
): ThreadControllerState {
  switch (event.type) {
    case 'START_NEW_CONVERSATION':
      return {
        activeThreadId: null,
        phase: 'idle',
        pendingSource: 'new_conversation',
        threadless: true,
      };

    case 'BEFORE_SEND':
      if (state.activeThreadId) return state;
      return {
        ...state,
        phase: 'creating',
        pendingSource: 'new_conversation',
        threadless: false,
      };

    case 'THREAD_CREATED':
      // Only accept created thread while creating/new conversation flow.
      if (state.pendingSource !== 'new_conversation' && state.phase !== 'creating') {
        return state;
      }
      return {
        activeThreadId: event.threadId,
        phase: 'active',
        pendingSource: null,
        threadless: false,
      };

    case 'SELECT_THREAD':
      return {
        activeThreadId: event.threadId,
        phase: 'switching',
        pendingSource: event.source ?? 'sidebar_select',
        threadless: false,
      };

    case 'SYNC_URL_THREAD':
      if (!event.threadId) {
        return {
          activeThreadId: null,
          phase: 'idle',
          pendingSource: state.pendingSource === 'new_conversation' ? 'new_conversation' : null,
          threadless: true,
        };
      }
      return {
        activeThreadId: event.threadId,
        phase: 'active',
        pendingSource: state.pendingSource === 'sidebar_select' ? 'sidebar_select' : 'url_nav',
        threadless: false,
      };

    case 'THREAD_LOAD_SUCCESS':
      return {
        activeThreadId: event.threadId,
        phase: 'active',
        pendingSource: null,
        threadless: false,
      };

    case 'THREAD_LOAD_FAILED':
      return {
        activeThreadId: null,
        phase: 'idle',
        pendingSource: null,
        threadless: true,
      };

    case 'CLEAR_PENDING_SOURCE':
      return {
        ...state,
        pendingSource: null,
      };

    default:
      return state;
  }
}

